module.exports = __webpack_public_path__ + "static/media/onlinestoreimg.522745d4.png";